import React from 'react';
import * as core from 'cw-ui-core';
import { injectIntl } from 'react-intl';
import css from './EntitlementAssignmentConfirmDialog.scss';

export const ENTITLEMENT_ASSIGNMENT_CONFIRM_DIALOG_KEY = 'entitlement_assignment_confirm_dialog';

const NON_BILLING_ENTITLEMENT_REVIEW_TITLE = 'Please review the entitlement(s) to be assigned:';
const BILLING_ENTITLEMENT_REVIEW_TITLE = 'Please review the billing entitlement(s) to be assigned:';

const EntitlementReviewSection = ({ title, entitlementNames }) => (
    <div className={css.reviewSection}>
        <core.Label bold italic value={title} />
        <core.Label italic className={css.entitlementNames} value={entitlementNames.join(', ')} />
    </div>
);

const EntitlementAssignmentConfirmDialog = props => (
    <div className={css.modalOverlay}>
        <core.Dialog
            className={css.dialog}
            includeCloseIcon
            onCloseIconClicked={props.onCancel}
            automationName={ENTITLEMENT_ASSIGNMENT_CONFIRM_DIALOG_KEY}>
            <div className={css.wrap}>
                <div className={css.reviewList}>
                    {props.nonBillingEntitlementNames?.length > 0 && (
                        <EntitlementReviewSection
                            title={NON_BILLING_ENTITLEMENT_REVIEW_TITLE}
                            entitlementNames={props.nonBillingEntitlementNames}
                        />
                    )}
                    {props.billingEntitlementNames?.length > 0 && (
                        <EntitlementReviewSection
                            title={BILLING_ENTITLEMENT_REVIEW_TITLE}
                            entitlementNames={props.billingEntitlementNames}
                        />
                    )}
                </div>
                <core.Flexbox className={css.btnWrap}>
                    <core.ButtonLight
                        className={css.noBtn}
                        automationName="cancel_entitlement_modal"
                        value="Cancel"
                        onClick={props.onCancel}
                    />
                    <core.ButtonStandard
                        automationName="confirm_add_entitlement"
                        value="Confirm"
                        onClick={props.onConfirm}
                    />
                </core.Flexbox>
            </div>
        </core.Dialog>
    </div>
);

export default injectIntl(EntitlementAssignmentConfirmDialog);
